/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Years_Experience_SubInputs */

const en_years_experience_sub = /** @type {(inputs: Years_Experience_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90+ cannabis cups`)
};

const th_years_experience_sub = /** @type {(inputs: Years_Experience_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลกว่า 90 รายการ`)
};

const ja_years_experience_sub = /** @type {(inputs: Years_Experience_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンナビスカップ90冠以上`)
};

const fr_years_experience_sub = /** @type {(inputs: Years_Experience_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de 90 cannabis cups`)
};

const es_years_experience_sub = /** @type {(inputs: Years_Experience_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más de 90 cannabis cups`)
};

const ru_years_experience_sub = /** @type {(inputs: Years_Experience_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Более 90 наград`)
};

const zh_years_experience_sub = /** @type {(inputs: Years_Experience_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90 多座大麻杯奖项`)
};

const vi_years_experience_sub = /** @type {(inputs: Years_Experience_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hơn 90 giải cannabis cup`)
};

/**
* | output |
* | --- |
* | "90+ cannabis cups" |
*
* @param {Years_Experience_SubInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const years_experience_sub = /** @type {((inputs?: Years_Experience_SubInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Years_Experience_SubInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_years_experience_sub(inputs)
	if (locale === "ja") return ja_years_experience_sub(inputs)
	if (locale === "fr") return fr_years_experience_sub(inputs)
	if (locale === "es") return es_years_experience_sub(inputs)
	if (locale === "ru") return ru_years_experience_sub(inputs)
	if (locale === "zh") return zh_years_experience_sub(inputs)
	if (locale === "vi") return vi_years_experience_sub(inputs)
	return en_years_experience_sub(inputs)
});